import React = require("react");
import styled from "styled-components";
import { getColor } from "../../../../../ui/_themes/helpers";

export const Wrapper = styled.div`
  color: ${getColor("displays")};
  justify-content: center;
  display: flex;
  flex: 1 0 auto;
  text-align: center;
`;

export const PlayForFunText = ({ text, dataE2EId }) => {
  return <Wrapper data-e2e-id={`${dataE2EId}`}>{text}</Wrapper>;
};
